(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const openButton = document.querySelector('[data-cart-open]');
  const closeButton = document.querySelector('[data-cart-close]');
  const body = document.querySelector('[data-cart-body]');
  const footer = document.querySelector('[data-cart-footer]');

  if (!drawer || !overlay || !openButton || !closeButton) return;

  let lastFocused = null;

  const openCart = () => {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('karu-cart-open');
    closeButton.focus();
  };

  const closeCart = () => {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('karu-cart-open');
    if (lastFocused) lastFocused.focus();
  };

  openButton.addEventListener('click', openCart);
  closeButton.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
  });

  const escapeHtml = (value = '') => {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  };

  const money = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const format = window.KaruTheme?.moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents || 0) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  };

  const renderCart = (cart) => {
    const count = document.querySelector('[data-cart-count]');
    if (count) count.textContent = `${cart.item_count} items`;

    if (!cart.items.length) {
      body.innerHTML = '<p class="karu-cart__empty">Your cart is empty</p>';
      footer.hidden = true;
      return;
    }

    body.innerHTML = `<div class="karu-cart__items">${cart.items.map((item, index) => `
      <article class="karu-cart__item" data-cart-line="${index + 1}">
        ${item.image ? `<img class="karu-cart__image" src="${escapeHtml(item.image)}&width=240" alt="${escapeHtml(item.product_title)}" width="120" height="150">` : ''}
        <div class="karu-cart__details">
          <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <p>${money(item.final_line_price)}</p>
          <label><span>Quantity</span><input type="number" min="0" value="${item.quantity}" data-cart-quantity data-line="${index + 1}"></label>
        </div>
      </article>`).join('')}</div>`;

    footer.hidden = false;
    const total = document.querySelector('[data-cart-total]');
    if (total) total.innerHTML = money(cart.total_price);
  };

  drawer.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;

    input.disabled = true;
    try {
      const root = window.KaruTheme?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.line), quantity: Math.max(0, Number(input.value) || 0) })
      });
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch (error) {
      input.disabled = false;
      window.location.assign('/cart');
    }
  });
})();

(() => {
  const body = document.body;
  if (!body || body.classList.contains('template-password')) return;

  const reveal = () => {
    body.classList.remove('karu-page-leaving');
    window.requestAnimationFrame(() => body.classList.add('karu-page-ready'));
  };

  reveal();
  window.addEventListener('pageshow', reveal);

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.dataset.noPageTransition !== undefined) return;
    if (link.target && link.target !== '_self') return;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;
    if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;

    event.preventDefault();
    body.classList.add('karu-page-leaving');
    window.setTimeout(() => window.location.assign(destination.href), 190);
  });
})();

(() => {
  document.querySelectorAll('[data-size-chart-trigger]').forEach((trigger) => {
    const modalId = trigger.getAttribute('aria-controls');
    const modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    const closeButtons = modal.querySelectorAll('[data-size-chart-close]');
    const dialog = modal.querySelector('[role="dialog"]');
    const visibleClose = modal.querySelector('.karu-size-chart__close');
    let hideTimer = null;

    const open = () => {
      if (hideTimer) window.clearTimeout(hideTimer);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('karu-size-chart-open');
      window.requestAnimationFrame(() => {
        modal.classList.add('is-open');
        if (visibleClose) visibleClose.focus();
      });
    };

    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('karu-size-chart-open');
      hideTimer = window.setTimeout(() => {
        modal.hidden = true;
      }, 180);
      trigger.focus();
    };

    trigger.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab' || !dialog) return;

      const focusable = [...dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.disabled && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();

(() => {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    if (!track || slides.length < 2 || !previous || !next) return;

    let index = 0;
    const update = () => {
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      if (current) current.textContent = String(index + 1);
    };

    const goTo = (target) => {
      index = Math.max(0, Math.min(slides.length - 1, target));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      update();
    };

    previous.addEventListener('click', () => goTo(index - 1));
    next.addEventListener('click', () => goTo(index + 1));
    track.addEventListener('scroll', () => {
      const width = track.clientWidth || 1;
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      update();
    }, { passive: true });
    update();
  });

  document.querySelectorAll('[data-direct-checkout-form]').forEach((form) => {
    const button = form.querySelector('[data-direct-checkout-button]');
    const error = form.querySelector('[data-product-error]');
    const price = document.querySelector('[data-product-price]');

    form.addEventListener('change', (event) => {
      const variant = event.target.closest('[name="id"]');
      if (variant && price && variant.dataset.variantPrice) {
        const cents = Number(variant.dataset.variantPrice);
        const format = window.KaruTheme?.moneyFormat || '${{amount}}';
        price.innerHTML = format.replace(/\{\{\s*amount\s*\}\}/g, (cents / 100).toFixed(2));
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const selected = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      if (!selected || selected.disabled) return;

      button.disabled = true;
      button.classList.add('is-loading');
      const originalLabel = button.textContent;
      button.textContent = 'Opening checkout...';
      error.hidden = true;

      try {
        const root = window.KaruTheme?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(selected.value), quantity: 1 }]
          })
        });
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || 'This size could not be added.');
        }
        window.location.assign(`${root}checkout`);
      } catch (problem) {
        error.textContent = problem.message || 'Something went wrong. Please try again.';
        error.hidden = false;
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
      }
    });
  });
})();
